import { ChannelType, Origin } from '../constants';

export const channelHasSessions = (channelType) => {
  const PROVIDERS_WITH_SESSIONS = [ChannelType.WA, ChannelType.WECHAT];

  return PROVIDERS_WITH_SESSIONS.includes(channelType);
};

export const getLastCustomerMsgByAgentID = (messages, agentID) =>
  messages
    .filter(
      (message) =>
        message.agent_id === agentID && message.origin === Origin.CUSTOMER
    )
    .reduce((latestMessage, message) => {
      if (new Date(message.sent ?? 0) > new Date(latestMessage?.sent ?? 0)) {
        return message;
      }

      return latestMessage;
    }, null);

const isMatchByName = (customer, searchQuery) =>
  customer.name ? !!customer.name.toLowerCase().match(searchQuery) : false;

const isMatchByPhone = (customer, searchQuery) =>
  !!`+${customer.phone}`.match(searchQuery);

export const isCustomerMatch = (customer, searchQuery) =>
  isMatchByName(customer, searchQuery) || isMatchByPhone(customer, searchQuery);

export const isEchoConversation = (conversation) =>
  conversation?.channelTypes?.includes(ChannelType.ECHO);
